import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CollateralManagementService from "services/Setup/LoanOrigination/CollateralManagement/CollateralManagementService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingCekNoDoc: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  cekNoDokument: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  collateralManagementList: [],
  statusRespon: 0,
};

const handleApiResponse = (response, rejectWithValue) => {
  if (response.status === 200) {
    if (response.data.status == "Success") {
      notification.success({
        message: response.data.status,
        description: response.data.message,
        duration: 3,
      });
    } else {
      notification.error({
        message: response.data.status,
        description: response.data.message,
        duration: 3,
      });
    }
    return response.data;
  } else {
    console.log("Selain Response 200");
    notification.error({
      message: "Error",
      description: "Unexpected response!",
      duration: 3,
    });
    return rejectWithValue({
      status: "Error",
      response: response?.data?.message || "Unexpected response!",
    });
  }
};

const handleApiError = (error, rejectWithValue) => {
  notification.error({
    message: error.response?.status || "Error",
    description: error.response?.statusText || "Unexpected error occurred",
    duration: 3,
  });
  return rejectWithValue(
    error.response?.data?.message || "Unexpected response!"
  );
};

export const postCollateralManagementSlice = createAsyncThunk(
  "CollateralManagement/postCollateralManagementSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      // console.log("responspostCollateralManagementSlicee", userInput);
      const response =
        await CollateralManagementService.posCollateralManagementService(
          userInput
        );

      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const putCollateralManagementSlice = createAsyncThunk(
  "CollateralManagement/putCollateralManagementSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralManagementService.putCollateralManagementService(
          userInput
        );
      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const deleteCollateralManagementSlice = createAsyncThunk(
  "CollateralManagement/deleteCollateralManagementSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralManagementService.deleteCollateralManagementService(
          userInput
        );
      return handleApiResponse(response, rejectWithValue);
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const getCollateralManagementSlice = createAsyncThunk(
  "CollateralManagement/getCollateralManagementSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      console.log("userInput", userInput);
      
      const response =
        await CollateralManagementService.getCollateralManagementService(
          userInput
        );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const getCollateralManagementApprovalSlice = createAsyncThunk(
  "CollateralManagement/getCollateralManagementApprovalSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralManagementService.getCollateralManagementApprovalService(
          userInput
        );
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const putApprovalCollateralSlice = createAsyncThunk(
  "CollateralManagement/putApprovalCollateralSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CollateralManagementService.approvalCollateralService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const returnCollateralSlice = createAsyncThunk(
  "CollateralManagement/returnCollateralSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CollateralManagementService.RequestedId(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);
export const checkDuplicateSlice = createAsyncThunk(
  "CollateralManagement/checkDuplicateSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CollateralManagementService.checkDuplicateService(
        userInput
      );
      console.log("responspostCollateralManagementSlicee", response?.data);

      if (response.status === 200) {
        if (response && response.data) {
          if (response?.data?.canProceed == "Success") {
            notification.success({
              message: "Success",
              description: response?.data?.message || "",
              duration: 3,
            });
          } else {
            notification.error({
              message: "Error",
              description: response?.data?.message || "",
              duration: 3,
            });
          }
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return handleApiError(error, rejectWithValue);
    }
  }
);

export const CollateralManagementSlice = createSlice({
  name: "CollateralManagement",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state,action) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state,action) => {
      state.loading = true;
    },
    resetStatusRespon: (state,action) => {
      state.statusRespon = "";
    },
    setcreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postCollateralManagementSlice.pending, (state,action) => {
        state.loadingFinancial2 = true;
      })
      .addCase(postCollateralManagementSlice.fulfilled, (state, action) => {
        // console.log("action.payloadpus", action.payload);

        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(postCollateralManagementSlice.rejected, (state, action) => {
        state.loadingFinancial2 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // put
      .addCase(putCollateralManagementSlice.pending, (state,action) => {
        state.loadingFinancial2 = true;
      })
      .addCase(putCollateralManagementSlice.fulfilled, (state, action) => {
        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(putCollateralManagementSlice.rejected, (state, action) => {
        state.loadingFinancial2 = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      // get all
      .addCase(getCollateralManagementSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(getCollateralManagementSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralManagementList = action?.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCollateralManagementSlice.pending, (state,action) => {
        state.loading = true;
        state.redirect = "";
      })
      // get approval all
      .addCase(
        getCollateralManagementApprovalSlice.pending,
        (state, action) => {
          state.loading = false;
          state.result = action.payload;
          state.showMessage = true;
        }
      )
      .addCase(getCollateralManagementApprovalSlice.fulfilled, (state,action) => {
        state.loading = false;
        state.collateralManagementList = action?.payload;
        state.getCount = action.payload.count;
      })
      .addCase(
        getCollateralManagementApprovalSlice.rejected,
        (state, action) => {
          state.loading = false;
          state.result = action.payload;
          state.showMessage = true;
        }
      )
      // Approval
      .addCase(putApprovalCollateralSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(putApprovalCollateralSlice.pending, (state,action) => {
        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(putApprovalCollateralSlice.fulfilled, (state, action) => {
        state.loading = false;
        // state.collateralManagementList = action?.payload;
        state.getCount = action.payload.count;
      })
      // Return Collateral
      .addCase(returnCollateralSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(returnCollateralSlice.pending, (state,action) => {
        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(returnCollateralSlice.fulfilled, (state, action) => {
        state.loading = false;
        // state.collateralManagementList = action?.payload;
        state.getCount = action.payload.count;
      })
      // delete Collateral
      .addCase(deleteCollateralManagementSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(deleteCollateralManagementSlice.pending, (state,action) => {
        state.loadingFinancial2 = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(deleteCollateralManagementSlice.fulfilled, (state, action) => {
        state.loading = false;
        // state.collateralManagementList = action?.payload;
        state.getCount = action.payload.count;
      })
      // Return Collateral
      .addCase(checkDuplicateSlice.rejected, (state, action) => {
        state.loadingCekNoDoc = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      .addCase(checkDuplicateSlice.pending, (state, action) => {
        console.log("checkDuplicateSlice pending", action);

        state.loadingCekNoDoc = true;
        state.redirect = "";
        state.result = state.payload;
        state.cekNoDokument = action;
      })
      .addCase(checkDuplicateSlice.fulfilled, (state, action) => {
        state.loadingCekNoDoc = false;
        // state.collateralManagementList = action?.payload;
        state.getCount = action.payload.count;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
} = CollateralManagementSlice.actions;

export default CollateralManagementSlice.reducer;
